<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Periode Penggajian
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Periode Penggajian</h5>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <dx-popup
          :visible="popupLoadingVisible"
          title="Generating gaji..."
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="300"
          :height="130"
        >
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem"
              role="status"
            ></div>
          </div>
        </dx-popup>

        <dx-popup
          :visible="popupWarningVisible"
          title="Konfirmasi data pegawai"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="400"
          :height="200"
        >
          <div>
            <p>
              <strong>Mohon cek kelengkapan data pegawai dan absensi</strong>
            </p>
            <p>
              <strong
                >Update data pekerjaan, KP dan KGB ke versi terbaru</strong
              >
            </p>
          </div>
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="cancelButtonOptions"
          />

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="confirmButtonOptionsWarning"
          />
        </dx-popup>

        <DxPopup
          :visible="popupVisible"
          title="Tambah data"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          :height="650"
          :width="550"
        >
          <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">Periode gaji</div>
              <div class="dx-field-value">
                <DxDateBox
                  :show-clear-button="true"
                  :use-mask-behavior="true"
                  :input-attr="{ 'aria-label': 'Date' }"
                  type="date"
                  displayFormat="monthAndYear"
                  :calendar-options="calendarMonthYear"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.tgl"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxDateBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pokok</div>
              <div class="dx-field-value">
                <DxSelectBox
                  :dataSource="gajiPokokSkemaSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_pokok_skema_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>
          </div>
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">
              Skema penggajian untuk masing-masing status pegawai
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Direktur Utama</div>
              <div class="dx-field-value">
                <DxSelectBox
                  :dataSource="gajiSkemaDirutSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_dirut_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Direktur Umum</div>
              <div class="dx-field-value">
                <DxSelectBox
                  :dataSource="gajiSkemaDirumSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_dirum_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Direktur Teknik</div>
              <div class="dx-field-value">
                <DxSelectBox
                  :dataSource="gajiSkemaDirtekSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_dirtek_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pegawai Tetap</div>
              <div class="dx-field-value">
                <DxSelectBox
                  :dataSource="gajiSkemaTetapSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_tetap_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pegawai Capeg</div>
              <div class="dx-field-value">
                <DxSelectBox
                  :dataSource="gajiSkemaCapegSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_capeg_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pekerja Honor</div>
              <div class="dx-field-value">
                <DxSelectBox
                  :dataSource="gajiSkemaHonorSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_honor_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pekerja Kontrak</div>
              <div class="dx-field-value">
                <DxSelectBox
                  :dataSource="gajiSkemaKontrakSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_kontrak_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>
          </div>

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="cancelButtonOptions"
          />

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="confirmButtonOptions"
          />
        </DxPopup>

        <DxDataGrid
          ref="gridRef"
          id="gridContainer"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          @editor-preparing="oneditorpreparing"
          :focused-row-index="0"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          @exporting="onExporting"
          :filter-sync-enabled="true"
          :remote-operations="true"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :scrolling="{ mode: 'virtual' }"
        >
          <DxScrolling mode="virtual" row-rendering-mode="virtual" />

          <DxExport :enabled="true" :allow-export-selected-data="true" />

          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem template="add-template" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <template #add-template>
            <DxButton
              v-if="can('gaji-create')"
              icon="add"
              @click="addPeriodeVisible()"
              text="Tambah Data"
              type="default"
              style="float: left"
              width="150px"
              styling-mode="filled"
            ></DxButton>
          </template>

          <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="150" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
          />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>

          <!-- <DxColumn
            data-field="tgl"
            caption="Periode Gaji"
            data-type="date"
            :display-format="'MM/yyyy'"
            :format="'MM/yyyy'"
            :calculate-filter-expression="calculateFilterExpression"
            :filter-operations="filterOperations"
            sort-order="desc"
            cell-template="tglGajiTemplate"
          /> -->
          <DxColumn
            data-field="tgl"
            caption="Periode Gaji"
            data-type="date"
            :display-format="'MM/yyyy'"
            :format="'MM/yyyy'"
            sort-order="desc"
            cell-template="tglGajiTemplate"
          />
          <template #tglGajiTemplate="{ data }">
            {{ formatMonth(data.text) }}
          </template>
          <DxColumn
            data-field="gaji_status_id"
            caption="Status"
            data-type="number"
            cell-template="statusTemplate"
          >
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="gajiStatusSource"
            />
          </DxColumn>
          <dx-column
            data-type="number"
            caption="Pengaturan penggajian"
            cell-template="gajiTemplate"
          >
          </dx-column>
          <dx-column
            data-type="number"
            caption="Dibuat oleh"
            cell-template="createdTemplate"
          >
          </dx-column>

          <template #gajiTemplate="{ data }">
            <div v-html="gajiTemplate(data)"></div>
          </template>

          <dx-column
            data-type="number"
            caption="Terakhir di update oleh"
            cell-template="updatedTemplate"
          >
          </dx-column>

          <dx-column caption="Daftar gaji" cell-template="gajiListTemplate">
          </dx-column>

          <template #gajiListTemplate="{ data }">
            <DxButton
              @click="clickGaji(data)"
              :text="gajiListTemplate(data, 'text')"
              :type="gajiListTemplate(data, 'type')"
              style="float: left"
              width="150px"
              styling-mode="filled"
            ></DxButton>
          </template>

          <template #createdTemplate="{ data }">
            <div v-html="userPrint(data, 'created')"></div>
          </template>

          <template #updatedTemplate="{ data }">
            <div v-html="userPrint(data, 'updated')"></div>
          </template>

          <template #statusTemplate="{ data }">
            <DxButton
              :text="buttonStatus(data, 'text')"
              :type="buttonStatus(data, 'type')"
              width="auto"
              height="18px"
            />
          </template>

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="id"
            data-type="number"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              style="margin: auto; display: block"
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import api from "@/api";
import _ from "lodash";
import can from "@/haspermission";
import { DateTime } from "luxon";
import { ODATA_BASE_URL } from "@/global-constants";
import { API_BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import router from "@/router";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDateBox from "devextreme-vue/date-box";
import DxSelectBox from "devextreme-vue/select-box";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import { useGajiPokokSkemaStore } from "@/stores/GajiPokokSkemaStore";
import { useGajiSkemaDirutStore } from "@/stores/GajiSkemaDirutStore";
import { useGajiSkemaDirumStore } from "@/stores/GajiSkemaDirumStore";
import { useGajiSkemaDirtekStore } from "@/stores/GajiSkemaDirtekStore";
import { useGajiSkemaTetapStore } from "@/stores/GajiSkemaTetapStore";
import { useGajiSkemaCapegStore } from "@/stores/GajiSkemaCapegStore";
import { useGajiSkemaHonorStore } from "@/stores/GajiSkemaHonorStore";
import { useGajiSkemaKontrakStore } from "@/stores/GajiSkemaKontrakStore";
import { usePenggajianStatusStore } from "@/stores/PenggajianStatusStore";
import notify from "devextreme/ui/notify";
import auth from "../auth";
import axios from "axios";

const options = ["Lihat rekap", "Print gaji", "Export excel file"];

const dataSource = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: `${ODATA_BASE_URL}/GajiPeriodes`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };

      // e.params.$orderby = "tgl desc";
    },
  }),
  expand: [
    "createdByUser",
    "updatedByUser",
    "gajiPokokSkema",
    "gajiSkemaDirut",
    "gajiSkemaDirum",
    "gajiSkemaDirtek",
    "gajiSkemaTetap",
    "gajiSkemaCapeg",
    "gajiSkemaHonor",
    "gajiSkemaKontrak",
  ],
});

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxDropDownButton,
    DxButton,
    DxExport,
    DxToolbar,
    DxItem,

    DxScrolling,
    DxPopup,
    DxToolbarItem,
    DxDateBox,
    DxSelectBox,
    DxValidator,
    DxRequiredRule,
  },
  setup() {
    const gajiPokokSkemaStore = useGajiPokokSkemaStore();
    const gajiSkemaDirutStore = useGajiSkemaDirutStore();
    const gajiSkemaDirumStore = useGajiSkemaDirumStore();
    const gajiSkemaDirtekStore = useGajiSkemaDirtekStore();
    const gajiSkemaTetapStore = useGajiSkemaTetapStore();
    const gajiSkemaCapegStore = useGajiSkemaCapegStore();
    const gajiSkemaHonorStore = useGajiSkemaHonorStore();
    const gajiSkemaKontrakStore = useGajiSkemaKontrakStore();
    const gajiStatusStore = usePenggajianStatusStore();

    return {
      gajiPokokSkemaStore,
      gajiSkemaDirutStore,
      gajiSkemaDirumStore,
      gajiSkemaDirtekStore,
      gajiSkemaTetapStore,
      gajiSkemaCapegStore,
      gajiSkemaHonorStore,
      gajiSkemaKontrakStore,
      gajiStatusStore,
    };
  },

  data() {
    return {
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      gajiPokokSkemaSource: null,
      gajiSkemaDirutSource: null,
      gajiSkemaDirumSource: null,
      gajiSkemaDirtekSource: null,
      gajiSkemaTetapSource: null,
      gajiSkemaCapegSource: null,
      gajiSkemaHonorSource: null,
      gajiSkemaKontrakSource: null,
      gajiStatusSource: null,
      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },

      gajiPeriode: {
        tgl: null,
        gaji_status_id: 1, //open untuk periode baru
        created_by_user_id: auth.getUser().id,
        gaji_pokok_skema_id: null,
        gaji_skema_dirut_id: null,
        gaji_skema_dirum_id: null,
        gaji_skema_dirtek_id: null,
        gaji_skema_tetap_id: null,
        gaji_skema_capeg_id: null,
        gaji_skema_honor_id: null,
        gaji_skema_kontrak_id: null,
      },
      popupVisible: false,
      popupWarningVisible: false,
      popupLoadingVisible: false,
      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupVisible = false;
          this.popupWarningVisible = false;
        },
      },

      confirmButtonOptions: {
        text: "Simpan",
        onClick: (e) => {
          this.addPeriode(e);
        },
      },
      confirmButtonOptionsWarning: {
        text: "Ya, Data Pegawai terupdate",
        onClick: () => {
          this.absenCheckExists();
          this.popupWarningVisible = false;
        },
      },

      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],
      numberingPageSize: 10,
      numberingPageNumber: 0,
      router: router,
      options: options,
      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/SimpegPegawais",
      //   key: "id",
      // }),
      filterValue: "",
      dataSource,
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterBuilder") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterBuilder") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterBuilder") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(tgl) lt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterBuilder") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(tgl) gt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (
          selectedFilterOperation === "between" &&
          target == "filterBuilder"
        ) {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(tgl) ge " +
              bulan1 +
              " and year(tgl) ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(tgl) le " +
              bulan2 +
              " and year(tgl) le " +
              filterValue[1].getFullYear(),
          ];

          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
      oneditorpreparing: function (e) {
        if (e.dataField === "tgl") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
      gajiPeriodeId: null,
      gajiPeriodeTgl: null,
    };
  },
  async mounted() {
    this.gajiPokokSkemaSource = await this.gajiPokokSkemaStore.get();
    this.gajiSkemaDirutSource = await this.gajiSkemaDirutStore.get();
    this.gajiSkemaDirumSource = await this.gajiSkemaDirumStore.get();
    this.gajiSkemaDirtekSource = await this.gajiSkemaDirtekStore.get();

    this.gajiSkemaTetapSource = await this.gajiSkemaTetapStore.get();
    this.gajiSkemaCapegSource = await this.gajiSkemaCapegStore.get();
    this.gajiSkemaHonorSource = await this.gajiSkemaHonorStore.get();
    this.gajiSkemaKontrakSource = await this.gajiSkemaKontrakStore.get();
    this.gajiStatusSource = await this.gajiStatusStore.get();
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  methods: {
    async absenCheckExists() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      await axios
        .post(`${API_BASE_URL}/absen_check_exists`, this.gajiPeriodeTgl, config)
        .then((response) => {
          if (response.data.status) {
            this.generateGaji();
          } else {
            notify(response.data.message, response.data.notify_type);
          }
        })
        .catch((error) => {
          this.popupLoadingVisible = false;
          console.log("absenCheckExists error", error);
          notify(
            "Pengecekan absensi gagal. " + error.response.data.message,
            "error"
          );
        });
    },
    async generateGaji() {
      //tambahkan gaji_periodes, generated true
      this.popupLoadingVisible = true;

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      await axios
        .post(`${API_BASE_URL}/gaji`, [this.gajiPeriodeId, false], config)
        .then((response) => {
          this.popupLoadingVisible = false;
          notify(response.data.message, response.data.notify_type);
          this.refreshDatagrid("gridRef");
        })
        .catch((error) => {
          this.popupLoadingVisible = false;
          console.log("generated gaji", error);
          notify("Penggajian gagal dilaksanakan. " + error.message, "error");
          this.refreshDatagrid("gridRef");
        });
    },
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";

      const date = DateTime.fromISO(isoDateString).setLocale("id");

      return date.monthLong + " " + date.year;
    },

    gajiListTemplate(data, flag) {
      var text = "";
      var type = "";
      if (data.data.generated) {
        text = "Lihat gaji";
        type = "success";
      } else {
        text = "Buat gaji";
        type = "danger";
      }

      if (flag === "text") return text;
      else if (flag === "type") return type;
    },
    clickGaji(data) {
      if (data.data.generated) {
        const url = this.$router.resolve({
          name: "gaji-list",
          query: { id: data.data.id, tgl: data.data.tgl },
        }).href;

        window.location.href = url;
      } else {
        //buat gaji baru
        if (this.can("gaji-create")) {
          this.gajiPeriodeId = data.data.id;
          this.gajiPeriodeTgl = data.data.tgl;
          this.popupWarningVisible = true;
        }
      }
    },
    gajiTemplate(data) {
      // return (
      //   "<strong>Skema gaji pokok:</strong> " +
      //   data.data.gajiPokokSkema.nama +
      //   "<br>" +
      //   "<strong>Direktur Utama:</strong> " +
      //   data.data.gajiSkemaDirut.nama +
      //   "<br>" +
      //   "<strong>Direktur Umum:</strong> " +
      //   data.data.gajiSkemaDirum.nama +
      //   "<br>" +
      //   "<strong>Direktur Teknik:</strong> " +
      //   data.data.gajiSkemaDirtek.nama +
      //   "<br>" +
      //   "<strong>Pegawai tetap:</strong> " +
      //   data.data.gajiSkemaTetap.nama +
      //   "<br>" +
      //   "<strong>Calon pegawai:</strong> " +
      //   data.data.gajiSkemaCapeg.nama +
      //   "<br>" +
      //   "<strong>Pekerja honor:</strong> " +
      //   data.data.gajiSkemaHonor.nama +
      //   "<br>" +
      //   "<strong>Pekerja kontrak:</strong> " +
      //   data.data.gajiSkemaKontrak.nama
      // );
      return (
        "<div style='margin-bottom: 10px;'><strong>Skema gaji pokok:</strong> " +
        data.data.gajiPokokSkema.nama +
        "</div>" +
        "<div style='margin-bottom: 10px;'>" +
        "<strong>Direktur Utama:</strong> " +
        data.data.gajiSkemaDirut.nama +
        "</div>" +
        "<div style='margin-bottom: 10px;'>" +
        "<strong>Direktur Umum:</strong> " +
        data.data.gajiSkemaDirum.nama +
        "</div>" +
        "<div style='margin-bottom: 10px;'>" +
        "<strong>Direktur Teknik:</strong> " +
        data.data.gajiSkemaDirtek.nama +
        "</div>" +
        "<div style='margin-bottom: 10px;'>" +
        "<strong>Pegawai tetap:</strong> " +
        data.data.gajiSkemaTetap.nama +
        "</div>" +
        "<div style='margin-bottom: 10px;'>" +
        "<strong>Calon pegawai:</strong> " +
        data.data.gajiSkemaCapeg.nama +
        "</div>" +
        "<div style='margin-bottom: 10px;'>" +
        "<strong>Pekerja honor:</strong> " +
        data.data.gajiSkemaHonor.nama +
        "</div>" +
        "<div style='margin-bottom: 10px;'>" +
        "<strong>Pekerja kontrak:</strong> " +
        data.data.gajiSkemaKontrak.nama +
        "</div>"
      );
    },
    formattedDate(tgl) {
      const jsDate = new Date(tgl);
      const dt = DateTime.fromJSDate(jsDate).setZone("Asia/Makassar");
      const convert = dt
        .setLocale("id")
        .toFormat("cccc dd MMMM yyyy HH:mm:ss 'WITA'");
      const originalDate = DateTime.fromFormat(
        convert,
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'",
        { locale: "id" }
      );

      const newDate = originalDate.plus({ hours: 8 });
      const formattedNewDate = newDate.toFormat(
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'"
      );
      return formattedNewDate;
    },
    userPrint(data, flag) {
      var nama = "";
      var tgl = "";
      if (flag === "created") {
        nama = data.data.createdByUser.name;
        tgl = this.formattedDate(data.data.created_at);
      } else if (data.data.updatedByUser) {
        nama = data.data.updatedByUser.name;
        tgl = this.formattedDate(data.data.updated_at);
      }

      if (_.isEmpty(nama)) nama = "";
      // if (_.isEmpty(tgl)) tgl = "";

      return nama + "<br>" + tgl;
    },
    buttonStatus(data, flag) {
      var type = this.gajiStatusSource.find((g) => g.id === data.value).warna;
      var text = this.gajiStatusSource.find((g) => g.id === data.value).nama;

      if (flag === "type") return type;
      else return text;
    },
    can,
    addPeriodeVisible() {
      this.popupVisible = true;
    },
    formatDateISO(dateOri) {
      const date = DateTime.fromJSDate(new Date(dateOri));
      return date.toFormat("yyyy-MM-dd");
    },
    async addPeriode(e) {
      const result = e.validationGroup.validate();
      if (result.isValid) {
        this.gajiPeriode.tgl = this.formatDateISO(this.gajiPeriode.tgl);
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        await axios
          .post(`${API_BASE_URL}/gajiPeriode`, this.gajiPeriode, config)
          .then((response) => {
            this.$refs.gridRef.instance.getDataSource().reload();
            this.popupVisible = false;

            notify(response.data.message, response.data.notify_type);
          })
          .catch((error) => {
            this.popupVisible = false;
            console.log(error);
            notify("Periode Penggajian gagal ditambahkan", "error");
          });
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar KGB.xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    onPageChanged(e) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    onItemClick(e) {
      let pegawaiId = e.element.id;

      // this.router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: pegawaiId },
      // });

      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: pegawaiId },
      }).href;
      window.open(url, "_blank");
    },
  },
};
</script>
